import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "./Pan.css";
import "../../CriminalCertificateValidation.css";

const Pan = () =>{
 return(
   <DocumentDetails documentType={'pans'} keyAccess={'HawkAI-PAN-V2'} title={'PAN'} exportDataToExcelName={'Pan-cardDocument'} analysefrom={'pan'} deleteText={'pan'} modelName={'doc-ai'} webSocketName = {'pan'}/>
 )
};
export default Pan;